import { CallbackWrap } from '@/types/common'
import { Embed } from '@/types/embed'
import { LevelingEmbed } from '@/types/leveling'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input } from 'components/editor/Input'
import React from 'react'
import './strengths-and-weaknesses.scss'

type SType = 'strengths' | 'weaknesses'
const defaultContent = {
  strengths: [],
  weaknesses: []
}

export function StrengthsAndWeaknesses({
  embed,
  onEmbedChange
}: {
  embed: LevelingEmbed
  onEmbedChange?: (value: CallbackWrap<Embed>) => void
}) {
  const content = embed?.overview?.strengthsAndWeaknesses ?? defaultContent
  const [isEditing, setIsEditing] = React.useState(false)

  const onAdd = React.useCallback(
    (type: SType) =>
      onEmbedChange?.((embed) => {
        if (embed.type !== 'leveling') return embed
        embed = { ...embed }
        embed.overview = { ...embed.overview }
        const snw = (embed.overview.strengthsAndWeaknesses = {
          ...(embed.overview.strengthsAndWeaknesses ?? defaultContent)
        })
        snw[type] = snw[type].slice()
        snw[type].push('')
        return embed
      }),
    [onEmbedChange]
  )

  const onDelete = (index: number, type: SType) =>
    onEmbedChange?.((embed) => {
      if (embed.type !== 'leveling') return embed
      embed = { ...embed }
      embed.overview = { ...embed.overview }
      const snw = (embed.overview.strengthsAndWeaknesses = {
        ...(embed.overview.strengthsAndWeaknesses ?? defaultContent)
      })
      snw[type] = snw[type].slice()
      snw[type].splice(index, 1)
      return embed
    })

  const onEditAttr = (index: number, newValue: string, type: SType) =>
    onEmbedChange?.((embed) => {
      if (embed.type !== 'leveling') return embed
      embed = { ...embed }
      embed.overview = { ...embed.overview }
      const snw = (embed.overview.strengthsAndWeaknesses = {
        ...(embed.overview.strengthsAndWeaknesses ?? defaultContent)
      })
      snw[type] = snw[type].slice()
      snw[type][index] = newValue
      return embed
    })

  return (
    <div className="poe-strengths-and-weaknesses">
      <div className="poe-title">
        Strengths And Weaknesses
        {onEmbedChange &&
          (isEditing ? (
            <div>
              <button onClick={() => setIsEditing(false)}>Close</button>
            </div>
          ) : (
            <div>
              <FontAwesomeIcon
                icon={faEdit}
                onClick={() => {
                  setIsEditing(!isEditing)
                }}
              />
            </div>
          ))}
      </div>

      {isEditing ? (
        <div className="poe-strengths-and-weaknesses-edit">
          <div className="poe-inner">
            <div className="poe-strengths">
              <span className="poe-subtitle">Strengths</span>
              <ul>
                {content.strengths.map((item, index) => (
                  <li key={index}>
                    <Input
                      placeholder="Enter text"
                      value={item}
                      onChange={(newValue) => {
                        onEditAttr(index, newValue, 'strengths')
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      onClick={() => {
                        onDelete(index, 'strengths')
                      }}
                    />
                  </li>
                ))}
              </ul>
              <button
                onClick={() => {
                  onAdd('strengths')
                }}>
                Add
              </button>
            </div>

            <div className="poe-weaknesses">
              <span className="poe-subtitle">Weaknesses</span>
              <ul>
                {content.weaknesses.map((item, index) => (
                  <li key={index}>
                    <Input
                      placeholder="Enter text"
                      value={item}
                      onChange={(newValue) => {
                        onEditAttr(index, newValue, 'weaknesses')
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      onClick={() => {
                        onDelete(index, 'weaknesses')
                      }}
                    />
                  </li>
                ))}
              </ul>
              <button
                onClick={() => {
                  onAdd('weaknesses')
                }}>
                Add
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="poe-inner">
          <div className="poe-strengths">
            <span className="poe-subtitle">Strengths</span>
            <ul>
              {content.strengths.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="poe-weaknesses">
            <span className="poe-subtitle">Weaknesses</span>
            <ul>
              {content.weaknesses.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  )
}
